import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42959550"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-info-wrapper" }

import CustomerInputBlock from "@/components/blocks/CustomerInputBlock.vue";
import ContentWrapper from "@/components/generics/ContentWrapper.vue";
import { useBookingStore } from "@/store/bookingStore";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerInfoView',
  setup(__props) {

const bookingStore = useBookingStore();

onMounted(() => {
  bookingStore.validateTicketsInCart(bookingStore.shoppingCart);
  bookingStore.validate_step("resenarer")
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentWrapper, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookingStore).shoppingCart, (value, index) => {
          return (_openBlock(), _createBlock(CustomerInputBlock, {
            key: `${index}-customerinfo-${value.id}`,
            index_in_shoppingcart: index,
            shopping_cart_ticket: value
          }, null, 8, ["index_in_shoppingcart", "shopping_cart_ticket"]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})